import { _mock } from "src/_mock";
import dayjs from "dayjs";
import { IAnvändare } from "@/src/types/nya/common";

// To get the user from the <AuthContext/>, you can use

// Change:
// import { useMockedUser } from 'src/auth/hooks';
// const { user } = useMockedUser();

// To:
// import { useAuthContext } from 'src/auth/hooks';
// const { user } = useAuthContext();

// ----------------------------------------------------------------------

export const ROTTNEVÄGEN43 = {
  gata: "Storgatan",
  nr: "1",
  våning: "",
  postNummer: "111 22",
  ort: "Stockholm",
  fullständigAdress: "Storgatan 1, 111 22 Stockholm",
};

export function useMockadAnvandare(): IAnvändare {
  const anvandare = {
    id: '111313',
    namn: {
      förnamn: "Alex",
      efternamn: "Andersson",
      fullständigtNamn: "Alex Andersson",
    },
    emailAdress: "demo@flinky.se",
    personNummer: "19900101-1234",
    telefonNummer: "070-0000000",
    harGenomgåttOnboarding: true,
    roller: [
      {
        aktiv: true,
        namn: "organisation_admin",
        skapadesPå: dayjs("2023-10-11"),
      },
      {
        aktiv: true,
        namn: "brf_styrelseledamot",
        skapadesPå: dayjs("2025-10-11"),
      },
      {
        aktiv: true,
        namn: "egenföretagare",
        skapadesPå: dayjs('2025-01-01'),
      },
    ],
    adress: ROTTNEVÄGEN43,
    koppladeOrganisationer: [{
      id: "2242",
      organisationsNamn: "Flinky Demo AB",
      organisationsNummer: "556000-0000",
      räkenskapsår: [],
      momsregisteringsnummer: "SE556000000001",
      organisationsTyp: "AKTIEBOLAG" as const,
      adress: ROTTNEVÄGEN43,
    }],
    avatarUrl: _mock.image.avatar(1),
    valtSpråk: "sv",
    address: ROTTNEVÄGEN43.fullständigAdress,
  };

  return anvandare;
}
